var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.accountId != 73
    ? _c(
        "header",
        { staticClass: "app-header navbar" },
        [
          _c(
            "button",
            {
              staticClass: "navbar-toggler mobile-sidebar-toggler d-lg-none",
              attrs: { type: "button" },
              on: { click: _vm.mobileSidebarToggle }
            },
            [_c("span", { staticClass: "navbar-toggler-icon" })]
          ),
          _vm._v(" "),
          _c("span", {
            staticClass: "navbar-brand",
            staticStyle: { width: "150px!important" },
            domProps: { innerHTML: _vm._s(_vm.svg.logo) }
          }),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "header-main", attrs: { justified: "" } },
            [
              _vm._l(_vm.headerItems, function(item, index) {
                return [
                  _c("NavItem", {
                    key: index,
                    attrs: {
                      name: item.name,
                      url: item.url,
                      svgIcon: item.svgIcon
                    }
                  })
                ]
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "right-menu" },
            [
              _vm.trialUser
                ? _c("div", [
                    _c("i", {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true }
                        }
                      ],
                      staticClass: "fa fa-2x fa-info-circle trial-user mr-5",
                      attrs: {
                        title: _vm.$t("HEADER.TRIAL_USER", {
                          END_DATE: _vm.endDate
                        })
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("HeaderDropdownAccnt")
            ],
            1
          )
        ],
        1
      )
    : _c(
        "div",
        {
          staticClass: "app-header navbar p-1",
          staticStyle: { background: "#fbfbfb" }
        },
        [
          _c(
            "b-row",
            { staticStyle: { width: "100%" } },
            [
              _c(
                "b-col",
                { staticClass: "text-center", attrs: { sm: "2" } },
                [
                  _c("router-link", {
                    attrs: { to: "/medical_insurance_cards/demo" },
                    domProps: { innerHTML: _vm._s(_vm.svg.logo) }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { staticClass: "text-center", attrs: { sm: "8" } }, [
                _c(
                  "h3",
                  {
                    staticStyle: {
                      color: "#4d4f52",
                      "font-weight": "bolder",
                      "padding-top": "10px"
                    }
                  },
                  [
                    _vm._v(
                      "\n        Medical Insurance Cards Processing using Document AI\n      "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { sm: "2" } },
                [
                  _c(
                    "b-navbar-nav",
                    {
                      staticStyle: {
                        "flex-direction": "column",
                        "padding-top": "10px"
                      }
                    },
                    [_c("MicpHeaderAccount")],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-741978ef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-741978ef","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/Header.vue
// module id = 950
// module chunks = 2